export enum HookReturnType {
  PRIMITIVE = 'PRIMITIVE',
  PROMISE = 'PROMISE',
  OBSERVABLE = 'OBSERVABLE',
}
